import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { loginSchema } from "../services/FormValidation";
import { doSignInWithEmailAndPassword } from "../database/auth";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { doPasswordReset } from "../database/auth";

const Login = () => {
  // const [showPassword, setShowPassword] = useState(true);
  const { userLoggedIn, loading } = useAuth();
  const navigate = useNavigate();

  const { register, handleSubmit, watch } = useForm({
    resolver: yupResolver(loginSchema),
  });
  const email = watch("email");

  const onSubmit = (data) => {
    console.log(data);
    signIn(data);
  };

  const signIn = async (data) => {
    try {
      const res = await doSignInWithEmailAndPassword(data.email, data.password);
      console.log(res);
      if (res) {
        Swal.fire({
          icon: "success",
          title: "Bienvenido!",
          text: "Has iniciado sesión correctamente",
        });
      }
    } catch (error) {
      console.log(error);
      if (error.code === "auth/invalid-credential") {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Email o contraseña incorrectos",
        });
      } else if (error.code === "auth/too-many-requests") {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Demasiadas solicitudes. Por favor, espere un momento.",
        });
      }
    }
  };

  useEffect(() => {
    if (!loading && userLoggedIn) {
      navigate("/");
    }
  }, [loading, userLoggedIn, navigate]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div class="login_main">
      <div class="login_main_block my-0 mx-auto flex flex-row justify-center max-w-[1240px]">
        <div class="login_form_container max-w-[500px] mt-[75px] mb-[120px] mx-auto w-full">
          <div class="login_title mb-[32px] font-[900] text-[40px] leading-[48px] text-center text-white tracking-tight">
            Inicie sesión en su cuenta
          </div>
          <div class="login_block w-full pt-[16px] pb-[20px] px-auto bg-[#444b5d] rounded-[8px] pt-[60px]">
            <div class="login_tab">
              <form onSubmit={handleSubmit(onSubmit)} class="login_form">
                <div class="login_input relative max-w-[366px] w-full mx-auto mb-[24px]">
                  <label class="login_label absolute top-[-8px] left-[10px] bg-[#444b5d] color-white/30 px-[6px] text-[14px] leading-[18px] z-10 text-white/30 font-bold">
                    Correo electrónico
                  </label>
                  <input
                    type="email"
                    name="email"
                    required="1"
                    placeholder="Email"
                    {...register("email")}
                    class="login_input_value w-full h-[48px] border border-white/10 border-[1px] rounded-[4px] py-[8px] pr-[8px] pl-[14px] text-[16px] leading-[20px] bg-[#444b5d] text-white/80 placeholder:text-white/20 outline-none"
                  ></input>
                </div>
                <div class="login_input relative max-w-[366px] w-full mx-auto mb-[24px]">
                  <label class="login_label absolute top-[-8px] left-[10px] bg-[#444b5d] color-white/30 px-[6px] text-[14px] leading-[18px] z-10 text-white/30 font-bold">
                    Contraseña
                  </label>
                  <input
                    type="password"
                    name="password"
                    required="1"
                    placeholder="Contraseña"
                    {...register("password")}
                    class="login_input_value w-full h-[48px] border border-white/10 border-[1px] rounded-[4px] py-[8px] pr-[8px] pl-[14px] text-[16px] leading-[20px] bg-[#444b5d] text-white/80 placeholder:text-white/20 outline-none"
                  ></input>
                </div>
                <div class="login_input relative max-w-[366px] w-full mx-auto mb-[24px]">
                  <div class="login_input_forgot">
                    <button
                      type="button"
                      onClick={() => doPasswordReset(email)}
                      class="text-[14px] leading-[18px] font-normal text-[#4a8ded] hover:text-[#4a8ded]/80 hover:underline transition duration-300 ease-in-out"
                    >
                      Restablecer contraseña
                    </button>
                  </div>
                </div>
                <button
                  type="submit"
                  className="btn flex items-center justify-center bg-[#4a8ded] rounded-lg text-white font-bold text-base py-[19px] shadow-btn-shadow-blue shadow-btnblue/25 mx-auto mb-[38px] max-w-[366px] w-full radius-[4px] hover:bg-[#4a8ded]/80 transition duration-300 ease-in-out"
                >
                  Iniciar sesión
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
